import { render } from "./AccountEmailSettings.vue?vue&type=template&id=59ed51c6&scoped=true"
import script from "./AccountEmailSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AccountEmailSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./AccountEmailSettings.vue?vue&type=style&index=0&id=59ed51c6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ed51c6"]])

export default __exports__